import APIClient from "../../../common/APIClient";
import {
  toggleShowAlert,
  displayError,
  SUCCESS_ALERT,
  MAX_ITEMS_IN_PAGE,
  setIsSaving,
} from "../commonActions";
import qs from "qs";

const FETCH_PERMISSIONS = "FETCH_PERMISSIONS";
const FETCH_ROLE_PERMISSIONS = "FETCH_ROLE_PERMISSIONS";
const FETCH_ROLE_PERMISSIONS_BY_ID = "FETCH_ROLE_PERMISSIONS_BY_ID";
const SET_ROLE_PERMISSION_BY_ID_FIELD_CHANGE =
  "SET_ROLE_PERMISSION_BY_ID_FIELD_CHANGE";
const SET_ROLE_PERMISSION_FIELD_CHANGE = "SET_ROLE_PERMISSION_FIELD_CHANGE";
const SET_PERMISSION = "SET_PERMISSION";
const RESET_PERMISSION = "RESET_PERMISSION";
const PERMISSION_FILTER = "PERMISSION_FILTER";

export const SET_PERMISSIONS_PAGINATION = "SET_PERMISSIONS_PAGINATION";
export const RESET_PERMISSIONS_PAGINATION = "RESET_PERMISSIONS_PAGINATION";

export const SUPER_ADMIN = 3;

const client = () => {
  var apiClient = new APIClient();
  return apiClient.make();
};
export const fetchPermissions = (filters = null) => {
  return (dispatch, getState) => {
    client()
      .get("permissions/list", {
        params: {
          filters,
        },
        paramsSerializer: (params) => {
          return qs.stringify(params);
        },
      })
      .then((json) => {
        const result = json.data;

        if (result) {
          let permissions = result.data;
          if (!permissions.length) {
            permissions = null;
          } else {
            let numItems = permissions.length;
            let min = getState().permissions.min;
            let max =
              numItems < MAX_ITEMS_IN_PAGE
                ? numItems
                : getState().permissions.max;

            const totalPages = Math.ceil(numItems / MAX_ITEMS_IN_PAGE);

            dispatch({
              type: SET_PERMISSIONS_PAGINATION,
              numItems,
              min,
              max,
              totalPages,
            });
          }

          dispatch({ type: FETCH_PERMISSIONS, permissions });
        }
      })
      .catch((error) => {
        dispatch(displayError(error));
      });
  };
};

export const fetchRolePermissions = (filters = null) => {
  return (dispatch, getState) => {
    client()
      .get("role-permissions/list", {
        params: {
          filters,
        },
        paramsSerializer: (params) => {
          return qs.stringify(params);
        },
      })
      .then((json) => {
        const result = json.data;
        if (result) {
          let permissions = result.data;
          if (!permissions.length) {
            permissions = null;
          }

          dispatch({ type: FETCH_ROLE_PERMISSIONS, permissions });
        }
      })
      .catch((error) => {
        dispatch(displayError(error));
      });
  };
};

export const fetchRolePermissionsById = (role_id = 1) => {
  return (dispatch) => {
    client()
      .get("role-permissions/get-by-role-id", {
        params: { role_id },
        paramsSerializer: (params) => {
          return qs.stringify(params);
        },
      })
      .then((json) => {
        const result = json.data;
        if (result) {
          let permissions = result.data;
          if (!permissions?.permissions?.length) {
            permissions = null;
          }
          dispatch({ type: FETCH_ROLE_PERMISSIONS_BY_ID, permissions });
        }
      })
      .catch((error) => {
        dispatch(displayError(error));
      });
  };
};

export const handleInputChange = (e, definedValue = null) => {
  return (dispatch) => {
    let value = {};
    if (!e && definedValue) {
      value = definedValue;
    } else {
      const id = e.target.id;

      value = {
        [id]: e.target.value,
      };
    }

    dispatch({ type: SET_ROLE_PERMISSION_BY_ID_FIELD_CHANGE, value });
  };
};

export const getPermission = (id) => {
  return (dispatch) => {
    client()
      .get("permissions/get", {
        params: {
          id,
        },
      })
      .then((json) => {
        const result = json.data;
        if (result) {
          let permission = result.data;
          dispatch({ type: SET_PERMISSION, permission });
        }
      })
      .catch((error) => {
        dispatch(displayError(error));
      });
  };
};

export const upsertPermission = (callback = null) => {
  return (dispatch, getState) => {
    dispatch(setIsSaving(true));

    const clientObj = getState().permissions.rolePermissionsByID;
    clientObj.permissions = clientObj?.permissions.map((p) => p.id) || []; //array of permission ids
    clientObj.role_name = clientObj?.role?.role_name || "";
    clientObj.role_id = clientObj?.role?.id || 0;
    delete clientObj.updated_at;
    delete clientObj.updated_by;
    delete clientObj.created_at;
    delete clientObj.created_by;

    const endpoint = "role-permissions/upsert";
    let message = "Role has been successfully created.";

    if (clientObj.role_id) {
      message = "Roles & Permissions has been successfully updated.";
    }

    client()
      .post(endpoint, clientObj)
      .then((json) => {
        const result = json.data;
        if (result) {
          dispatch(toggleShowAlert(true, SUCCESS_ALERT, message));
          if (!clientObj.id) {
            const value = { id: result.data };
            dispatch({ type: SET_ROLE_PERMISSION_FIELD_CHANGE, value });
          }
        }
      })
      .finally(() => {
        dispatch(setIsSaving(false));
        window.location.replace("/#/settings/roles-permissions");
      })
      .catch((error) => {
        console.log(error);
        dispatch(displayError(error));
      });
  };
};

export const resetPermission = () => {
  return (dispatch) => {
    dispatch({ type: RESET_PERMISSION });
  };
};

export const filterPermissions = (filter) => {
  return (dispatch) => {
    dispatch({ type: PERMISSION_FILTER, filter });
  };
};
